import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-guidance-category',
    templateUrl: './common-guidance-category.component.html',
    styleUrls: ['./common-guidance-category.component.scss'],
    standalone: false
})
export class CommonGuidanceCategoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
